
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7d5a3d53&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Collection.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Collection.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7d5a3d53!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Collection.vue"),
  /* scopeId */
  "data-v-7d5a3d53",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Approvals/Collection.vue
// module id = 663
// module chunks = 0